import React, {useEffect, useRef, useState} from 'react';
import {
   FlatList,
   StyleSheet,
   View,
   TouchableOpacity,
   Dimensions,
   Text,
   Platform,
   Image,
} from 'react-native';
import {
   getAllSmallAlphabets,
   FONT_FAMILY_REGULAR,
   parseSpecialChar,
   WHITE_TEXT_HOVER_COLOR,
   rectifyBooleanString,
   isMacOS,
   aslCloseHandler,
} from '../../utils/utils';

import {useDispatch, useSelector} from 'react-redux';
import {selectScreenOrientation} from '../../redux/slices/ScreenOrientationSlice';
import logger from '../../utils/logger';
import {FONT_FAMILY_BOLD} from '../../utils/utils';
import {ImageQuestionHeader} from './ImageQuestionHeader';
import Asl from '../../components/asl';
import {isAndroid, isIOS} from 'react-device-detect';
import {selectAslType} from '../../redux/slices/AslSlice';

const FinalQuestionList = props => {
   const {
      answer,
      isLandscapeMode,
      isSmallScreen,
      finalQuesAnsData,
      currentFinalQuesIndex,
      isImageAvailable,
      isWeb,
      imageURL,
      onImageViewerPressed,
      wrongAnserID,
   } = props;
   const tempQues =
      'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s end Lorem Ipsum has been the industrys standard';

   const flatListRef = useRef();
   const [currentPlayingIndex, setCurrentPlayingIndex] = useState(null);
   useEffect(() => {
      flatListRef.current.scrollToOffset({animated: false, offset: 0});
   }, [answer]);
   useEffect(() => {
      if (props.isAslQuestion || props.didVideoStopped) {
         setCurrentPlayingIndex(null);
      }
   }, [props.isAslQuestion, props.didVideoStopped]);
   const QuestionHeaderComponent = () => {
      logger('currentFinalQuesIndex::', currentFinalQuesIndex);
      logger('finalQuesAnsData::', finalQuesAnsData);
      return (
         <View style={{flex: 1, flexDirection: 'row'}}>
            <View
               style={{
                  flex: isImageAvailable ? 0.8 : 1,
                  marginLeft: isLandscapeMode ? 25 : 16,
                  marginRight: isLandscapeMode ? 25 : 16,
                  flexDirection: 'row',
               }}>
               <Text
                  style={{
                     marginTop: isLandscapeMode ? 16 : 6,
                     fontSize: isLandscapeMode ? 32 : 20,
                     fontFamily: FONT_FAMILY_BOLD,
                     color: 'white',
                     fontWeight: '600',
                     ...Platform.select({
                        web: {
                           marginTop: !isSmallScreen() ? 16 : 8,
                           fontSize: !isSmallScreen() ? 32 : 20,
                        },
                     }),
                  }}>
                  {finalQuesAnsData?.[currentFinalQuesIndex].Question.replace(
                     isMacOS ? /\u0019/g : '\u0019',
                     "'",
                  )}
                  {/*tempQues*/}
               </Text>
            </View>
            {isImageAvailable ? (
               <View style={{flex: 0.2, marginTop: isLandscapeMode ? 24 : 8}}>
                  <ImageQuestionHeader
                     width={isLandscapeMode ? 150 : 100}
                     height={isLandscapeMode ? 52 : 50}
                     magnifierImageWidth={
                        !isWeb
                           ? isLandscapeMode
                              ? 40
                              : 30
                           : !isSmallScreen()
                           ? 50
                           : 30
                     }
                     magnifierImageHeight={
                        !isWeb
                           ? isLandscapeMode
                              ? 40
                              : 30
                           : !isSmallScreen()
                           ? 50
                           : 30
                     }
                     imageURL={imageURL}
                     onClick={() => {
                        onImageViewerPressed();
                     }}
                  />
               </View>
            ) : logger('Image not available', )}
         </View>
      );
   };

   const renderItem = ({item, index}) => {
      return (
         <FinalQuestionListItem
            index={index}
            answerData={item}
            onItemClick={item => {
               props.onRowSelected(item);
            }}
            onSignButtonPress={url => {
               if (currentPlayingIndex === index) {
                  setCurrentPlayingIndex(null);
                  return;
               }
               setCurrentPlayingIndex(index);
               props.onSignButtonPress(url);
            }}
            progressALSVideo={
               currentPlayingIndex === index ? props.progressALSVideo : 0
            }
            isMediaPlaying={props.isMediaPlaying}
            onMediaClicked={() => {
               props.onMediaClicked(currentPlayingIndex === index);
               if (currentPlayingIndex === index) {
                  setCurrentPlayingIndex(null);
                  return;
               }
               setCurrentPlayingIndex(index);
            }}
            onMediaFinished={() => {
               //To stop the progress bar
               setCurrentPlayingIndex(null);
            }}
            isPlaying={index === currentPlayingIndex}
            wrongAnserID={wrongAnserID}
         />
      );
   };

   return (
      <FlatList
         ref={flatListRef}
         ListHeaderComponent={<QuestionHeaderComponent />}
         data={answer}
         renderItem={renderItem}
         numColumns={1}
         keyExtractor={item => item.AnswerID}
      />
   );
};
const FinalQuestionListItem = props => {
   const dispatch = useDispatch();
   const isLandscapeMode = useSelector(selectScreenOrientation);
   const AslType = useSelector(selectAslType);
   const {answerData, index, wrongAnserID} = props;
   const [answerHeaderTexts, setAnswerHeaderTexts] = useState([]);
   const [answerTexts, setAnswerTexts] = useState('');
   const [isHover, setHover] = useState(false);
   useEffect(() => {
      splitAnswerTexts();
   });
   function splitAnswerTexts() {
      if (
         answerData.Answer.includes(')') &&
         answerData.Answer.split(')')[0].length === 1
      ) {
         setAnswerHeaderTexts(answerData.Answer.split(')')[0]);
         const indexOfColosingChar = answerData.Answer.indexOf(')') + 1;
         setAnswerTexts(answerData.Answer.substring(indexOfColosingChar));
      } else {
         const headerText = getAllSmallAlphabets(index);
         setAnswerHeaderTexts(headerText);
         setAnswerTexts(answerData.Answer);
      }
   }
   const anserBgColor =
      wrongAnserID != ''
         ? wrongAnserID === answerData.AnswerID
            ? '#FFDCDA'
            : rectifyBooleanString(answerData.CorrectAnswer)
            ? '#8FE7B8'
            : '#454545'
         : '#454545';
   const OptionHeaderBgColor =
      wrongAnserID != ''
         ? wrongAnserID === answerData.AnswerID
            ? '#FF3838'
            : rectifyBooleanString(answerData.CorrectAnswer)
            ? '#11A75C'
            : '#808080'
         : '#808080';
   const OptionTextColor =
      wrongAnserID != ''
         ? wrongAnserID === answerData.AnswerID
            ? '#FF3838'
            : rectifyBooleanString(answerData.CorrectAnswer)
            ? '#11A75C'
            : '#FFFFFF'
         : '#FFFFFF';
   const OptionTextHoverColor =
      wrongAnserID != ''
         ? wrongAnserID === answerData.AnswerID
            ? '#F00'
            : rectifyBooleanString(answerData.CorrectAnswer)
            ? 'green'
            : WHITE_TEXT_HOVER_COLOR
         : WHITE_TEXT_HOVER_COLOR;
   return (
      <TouchableOpacity
         onMouseEnter={() => setHover(true)}
         onMouseLeave={() => setHover(false)}
         style={{flex: 1}}
         onPress={() => {
            logger('correctAns::', answerData.CorrectAnswer);
            //if (answerData?.TestItemAnswerMediaRelativePath) {
            if (['audio', 'video'].includes(AslType)) {
               aslCloseHandler(dispatch);
            }
            props.onItemClick(answerData);
         }}>
         <View
            style={{
               flex: 1,
               marginTop: isLandscapeMode ? 16 : 8,
               flexDirection: 'row',
               borderRadius: 8,
               marginLeft: isLandscapeMode ? 25 : 16,
               marginRight: isLandscapeMode ? 25 : 16,
               minHeight: isLandscapeMode ? 64 : 48,
               backgroundColor: anserBgColor,
            }}>
            <View
               style={[
                  styles.answerHeaderContainer,
                  {
                     width: isLandscapeMode ? 64 : 48,
                     backgroundColor: OptionHeaderBgColor,
                  },
               ]}>
               <Text
                  style={[
                     styles.answerHeaderText,
                     {
                        fontSize: 24,
                        width: Platform.OS === 'windows' ? '20%' : null,
                     },
                     isHover && {color: WHITE_TEXT_HOVER_COLOR},
                  ]}>
                  {answerHeaderTexts}
               </Text>
            </View>
            <View style={styles.answerContainer}>
               <Text
                  style={[
                     styles.answerText,
                     {
                        fontSize: isLandscapeMode ? 20 : 16,
                        color: OptionTextColor,
                        //width: Platform.OS === 'windows' ? 'auto' : null,
                     },
                     isHover && {color: OptionTextHoverColor},
                  ]}>
                  {parseSpecialChar(answerTexts)}
               </Text>
               {answerData?.TestItemAnswerMediaRelativePath ? (
                  <Asl
                     url={answerData?.TestItemAnswerMediaRelativePath}
                     showAlsVideo={url => {
                        props.onSignButtonPress(url);
                     }}
                     progressALSVideo={props.progressALSVideo}
                     onMediaClicked={() => {
                        props.onMediaClicked();
                     }}
                     isMediaPlaying={props.isPlaying}
                     isVideoPlaying={props.isMediaPlaying && props.isPlaying}
                     style={{
                        marginTop: isAndroid ? 0 : 5,
                        marginLeft: 3,
                        ...Platform.select({
                           android: {
                              marginTop: 1,
                              marginLeft: 3,
                           },
                           ios: {
                              marginLeft: 3,
                              marginTop: 0,
                           },
                           macos: {
                              marginTop: 1,
                           },
                           windows: {
                              marginTop: 0,
                           },
                        }),
                     }}
                     onMediaFinished={() => {
                        props.onMediaFinished();
                     }}
                     progCircleTintColor="#454545"
                  />
               ) : null}
            </View>
         </View>
      </TouchableOpacity>
   );
};

const styles = StyleSheet.create({
   answerHeaderContainer: {
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: 8,
   },

   answerHeaderText: {
      fontFamily: FONT_FAMILY_REGULAR,
      color: 'white',
      fontWeight: '600',
   },
   answerContainer: {
      flex: 0.9,
      flexDirection: 'row',
      paddingLeft: 16,
      paddingRight: 5,
      alignItems: 'center',
   },
   answerText: {
      fontFamily: FONT_FAMILY_REGULAR,
      padding: 4,
   },
});
export default FinalQuestionList;
